import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.125rem;

  @media (min-width: 768px) {
    gap: 0.5rem;
  }

  .cart-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border-radius: 50%;
    color: #4a4a4a;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: #111718;
      background: #f5f5f5;
    }
  }

  @media (min-width: 768px) {
    .cart-btn {
      width: 40px;
      height: 40px;
    }
  }

  .cart-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    
    svg {
      font-size: 1.125rem;
    }
  }

  @media (min-width: 768px) {
    .cart-container svg {
      font-size: 1.25rem;
    }
  }

  .cart-value {
    position: absolute;
    top: -6px;
    right: -6px;
    background: #17bfcf;
    min-width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 0.625rem;
    font-weight: 600;
    color: white;
    padding: 0 3px;
  }

  @media (min-width: 768px) {
    .cart-value {
      top: -8px;
      right: -8px;
      min-width: 18px;
      height: 18px;
      font-size: 0.6875rem;
      padding: 0 4px;
    }
  }

  .auth-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 50%;
    color: #4a4a4a;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: #111718;
      background: #f5f5f5;
    }

    svg {
      font-size: 1.125rem;
    }
  }

  @media (min-width: 768px) {
    .auth-btn {
      width: 40px;
      height: 40px;

      svg {
        font-size: 1.25rem;
      }
    }
  }

  .profile-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid transparent;
    transition: all 0.3s ease;

    &:hover {
      border-color: #17bfcf;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media (min-width: 768px) {
    .profile-btn {
      width: 36px;
      height: 36px;
    }
  }
`;

export default Wrapper;
